export const UPDATED_CURRENT_MENU = "UPDATED_CURRENT_MENU";
export const UPDATED_CHECKOUT_PREVIOUS_MENU = "UPDATED_CHECKOUT_PREVIOUS_MENU";
export const UPDATED_GO_BACK_FROM_CHECKOUT = "UPDATED_GO_BACK_FROM_CHECKOUT";
export const UPDATE_CLOSE_APPOINTMENT_MODAL_VISIBILITY =
  "UPDATE_CLOSE_APPOINTMENT_MODAL_VISIBILITY";
export const UPDATE_CANCEL_APPOINTMENT_MODAL_VISIBILITY =
  "UPDATE_CANCEL_APPOINTMENT_MODAL_VISIBILITY";
export const UPDATE_CANCEL_RECURRING_APPOINTMENT_VISIBILITY =
  "UPDATE_CANCEL_RECURRING_APPOINTMENT_VISIBILITY";

export const UPDATE_GO_BACK_FROM_CUSTOMER_PAGE_MODAL_VISIBILITY =
  "UPDATE_GO_BACK_FROM_CUSTOMER_PAGE_MODAL_VISIBILITY";
export const UPDATE_WHERE_TO_GO_FROM_CUSTOMER_PAGE_MODAL =
  "UPDATE_WHERE_TO_GO_FROM_CUSTOMER_PAGE_MODAL";
export const UPDATE_RECURSIVE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY =
  "UPDATE_RECURSIVE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY";
export const UPDATE_GO_BACK_FROM_BOOKING_ONLY_CUSTOMER_PAGE_MODAL_VISIBILITY =
  "UPDATE_GO_BACK_FROM_BOOKING_ONLY_CUSTOMER_PAGE_MODAL_VISIBILITY";
export const UPDATE_SEND_CANCELLATION_EMAIL_TOGGLE =
  "UPDATE_SEND_CANCELLATION_EMAIL_TOGGLE";

export const UPDATE_RESTORE_APPOINTMENT_MODAL_VISIBILITY =
  "UPDATE_RESTORE_APPOINTMENT_MODAL_VISIBILITY";

export const UPDATE_SEND_RESTORATION_EMAIL_TOGGLE =
  "UPDATE_SEND_RESTORATION_EMAIL_TOGGLE";
export const UPDATE_MULTISERVICE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY =
  "UPDATE_MULTISERVICE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY";

export const UPDATE_STORE_CARD_FOR_LATER_MODAL_VISIBILITY =
  "UPDATE_STORE_CARD_FOR_LATER_MODAL_VISIBILITY";

export const UPDATE_CLOSE_WAITLIST_MODAL_VISIBILITY =
  "UPDATE_CLOSE_WAITLIST_MODAL_VISIBILITY";

export const UPDATE_BOOKING_CUSTOMER_PROFILE_MODAL_VISIBILITY =
"UPDATE_BOOKING_CUSTOMER_PROFILE_MODAL_VISIBILITY";

export const UPDATE_ZERO_DOLLAR_MODAL_VISIBILITY = 
"UPDATE_ZERO_DOLLAR_MODAL_VISIBILITY";

import { call, put } from "redux-saga/effects";

export function updateCurrentMenu(currentMenu) {
  return {
    type: UPDATED_CURRENT_MENU,
    data: currentMenu
  };
}

export function updateSendCancellationEmailToggle(toggled) {
  return {
    type: UPDATE_SEND_CANCELLATION_EMAIL_TOGGLE,
    data: toggled
  };
}

export function updateSendRestorationEmailToggle(toggled) {
  return {
    type: UPDATE_SEND_RESTORATION_EMAIL_TOGGLE,
    data: toggled
  };
}

export function updateCheckoutPreviousMenu(previousMenu) {
  return {
    type: UPDATED_CHECKOUT_PREVIOUS_MENU,
    data: previousMenu
  };
}

export function updateGoBackFromCheckoutAndShowModal(goBackFromCheckout) {
  return {
    type: UPDATED_GO_BACK_FROM_CHECKOUT,
    data: goBackFromCheckout
  };
}

export function updateStoreCardForLaterModalVisibility(visible) {
  return {
    type: UPDATE_STORE_CARD_FOR_LATER_MODAL_VISIBILITY,
    data: visible
  };
}

export function updateCloseAppointmentModalVisibility(visible) {
  return {
    type: UPDATE_CLOSE_APPOINTMENT_MODAL_VISIBILITY,
    data: visible
  };
}

export function updateCancelAppointmentModalVisibility(isVisible) {
  return {
    type: UPDATE_CANCEL_APPOINTMENT_MODAL_VISIBILITY,
    data: isVisible
  };
}

export function updateCancelRecurringAppointmentVisibility(isVisible) {
  return {
    type: UPDATE_CANCEL_RECURRING_APPOINTMENT_VISIBILITY,
    data: isVisible
  };
}

export function updateGoBackFromCustomerPageModalVisibility(isVisible) {
  return {
    type: UPDATE_GO_BACK_FROM_CUSTOMER_PAGE_MODAL_VISIBILITY,
    data: isVisible
  };
}

export function updateRestoreAppointmentModalVisibility(isVisible) {
  return {
    type: UPDATE_RESTORE_APPOINTMENT_MODAL_VISIBILITY,
    data: isVisible
  };
}
export function updateGoBackFromBookingOnlyCustomerPageModalVisibility(
  isVisible
) {
  return {
    type: UPDATE_GO_BACK_FROM_BOOKING_ONLY_CUSTOMER_PAGE_MODAL_VISIBILITY,
    data: isVisible
  };
}

export function updateWhereToGoFromCustomerPageModal(locationToGoTo) {
  return {
    type: UPDATE_WHERE_TO_GO_FROM_CUSTOMER_PAGE_MODAL,
    data: locationToGoTo
  };
}

export function updateRecurringAppointmentConfirmationModalVisibility(
  isVisible,
  closeAppWhenRecursiveAppointmentModalCloses
) {
  return {
    type: UPDATE_RECURSIVE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY,
    data: { isVisible, closeAppWhenRecursiveAppointmentModalCloses }
  };
}

export function updateMultiServiceAppointmentConfirmationModalVisibility(
  isVisible,
  closeAppWhenMultiserviceModalCloses
) {
  return {
    type: UPDATE_MULTISERVICE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY,
    data: { isVisible, closeAppWhenMultiserviceModalCloses }
  };
}

export function updateCloseWaitlistModalVisibility(isVisible) {
  return {
    type: UPDATE_CLOSE_WAITLIST_MODAL_VISIBILITY,
    data: isVisible
  };
}

export function updateBookingCustomerProfileModalVisibility(isVisible){
  return {
    type: UPDATE_BOOKING_CUSTOMER_PROFILE_MODAL_VISIBILITY,
    data : {isVisible}
  }
}

export function updateZeroDollarModalVisibility(isVisible) {
  return {
    type : UPDATE_ZERO_DOLLAR_MODAL_VISIBILITY,
    data : {isVisible}
  }
}

